<template>
  <div>
    <span style="margin-right: 10px" @click="openSwitch">
      {{ $t('main.change_identity' )}}
    </span>
    <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial;margin-right: 20px">
      <span style="cursor: pointer">
        <a-avatar class="avatar" size="small" shape="circle"
                  :src="avatar"/>
        <span class="curr-user">{{user.username}}</span>
      </span>
      <a-menu style="width: 150px" slot="overlay">
        <a-menu-item @click="openProfile">
          <a-icon type="user"/>
          <span>{{ $t('home.personal_center') }}</span>
        </a-menu-item>
        <a-menu-item @click="updatePassword">
          <a-icon type="key"/>
          <span>{{ $t('home.password_modification') }}</span>
        </a-menu-item>
        <!-- <a-menu-divider></a-menu-divider> -->
        <!-- <a-menu-item @click="handleSettingClick">
          <a-icon type="setting"/>
          <span>系统定制</span>
        </a-menu-item> -->
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="logout">
          <a-icon type="logout"/>
          <span>{{ $t('home.log_out') }}</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <!-- i18n -->
    <a-popover trigger="hover" placement="bottomRight">
      <a-menu
        style="width: 120px"
        slot="content"
        v-model="language"
        @select="languageSelect"
      >
        <a-menu-item key="zh-cn">
          <span>简体中文</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item key="en-us">
          <span>English</span>
        </a-menu-item>
      </a-menu>
      <img src="../../../static/img/vector.png" style="width: 20px;height: 20px"/>
    </a-popover>
    <update-password
      @success="handleUpdate"
      @cancel="handleCancelUpdate"
      :user="user"
      :updatePasswordModelVisible="updatePasswordModelVisible">
    </update-password>

    <switch-identities ref="switchIdentities"></switch-identities>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import UpdatePassword from '../personal/UpdatePassword'
import I18nSelector from './i18nSelector'
import SwitchIdentities from './SwitchIdentities.vue'
export default {
  name: 'HeaderAvatar',
  components: {UpdatePassword, I18nSelector, SwitchIdentities},
  data () {
    return {
      updatePasswordModelVisible: false,
      language: ['zh-cn'],
      modelVisible: false
    }
  },
  computed: {
    ...mapState({
      settingBar: state => state.setting.settingBar.opened,
      user: state => state.account.user
    }),
    avatar () {
      return this.user.avatar
      // return `static/avatar/${this.user.avatar}`
    }
  },
  created () {
    this.$root.$on('changePassword', this.updatePassword)
  },
  mounted () {
    var locale = this.$i18n.locale
    this.language[0] = locale
  },
  methods: {
    languageSelect ({ key }) {
      this.$db.save('language', key)
      this.$i18n.locale = key
      // if (this.$route.path === '/login') return
      location.reload()
    },
    handleSettingClick () {
      this.setSettingBar(!this.settingBar)
    },
    openProfile () {
      this.$router.push('/profile')
    },
    updatePassword () {
      this.updatePasswordModelVisible = true
    },
    handleCancelUpdate () {
      this.updatePasswordModelVisible = false
    },
    handleUpdate () {
      this.updatePasswordModelVisible = false
      this.$message.success('更新密码成功，请重新登录系统')
      setTimeout(() => {
        this.logout()
      }, 1500)
    },
    logout () {
      this.$get(`logout/${this.user.id}`).then(() => {
        return new Promise((resolve, reject) => {
          this.$db.clear()
          location.reload()
        })
      }).catch(() => {
        this.$message.error('退出系统失败')
      })
    },
    openSwitch () {
      this.$refs.switchIdentities.getHospitalList()
      this.$refs.switchIdentities.form.higherHospitalUuid = this.$store.state.account.hospital
      this.$refs.switchIdentities.modelVisible = true
    },
    ...mapMutations({setSettingBar: 'setting/setSettingBar'})
  }
}
</script>

<style lang="less" scoped>
  .ant-avatar-sm {
    width: 30px;
    height: 30px;
  }
  .avatar {
    margin: 20px 4px 20px 0;
    color: #1890ff;
    background: hsla(0, 0%, 100%, .85);
    vertical-align: middle;
  }
  .curr-user {
    font-weight: 600;
    margin-left: 6px
  }
</style>



// WEBPACK FOOTER //
// src/views/common/HeaderAvatar.vue